import Pig from '../../assets/dynamic-color-svgs/Pig';

const ProcessingPaymentSpinner = () => (
  <div className="flex w-full flex-col items-center gap-12 py-12">
    <div className="mx-auto size-[193px] animate-[spin_3.5s_linear_infinite]">
      <Pig />
    </div>
  </div>
);

export default ProcessingPaymentSpinner;
